interface GameStatsProps {
  level: number
  score: number
  className?: string
}

export const GameStats = ({ level, score, className = "" }: GameStatsProps) => {
  return (
    <div id="game-stats" className={className}>
      <p>Level: {level}</p>
      <p>Score: {score}</p>
    </div>
  )
}
